export const WALLET_SWEEP_REQUEST_EXPIRATION_DURATION_MS = 43200000 as const;
export const CONTRACT_INTERNAL_DECIMALS = 18 as const;
export const CONTRACT_MULTIPLIER_DECIMALS = 2;
export const OFFCHAIN_BALANCE_DECIMALS = 2 as const;
export const POWERPLAY_COMBO_MIN_PICKS_COUNT = 2 as const
export const FLEXPLAY_COMBO_MIN_PICKS_COUNT = 3 as const
export const COMBO_MAX_PICKS_COUNT = 6 as const

// Constant for voided event outcome ID (bytes12(0))
export const VOIDED_EVENT_OUTCOME_ONCHAIN_ID = "0x000000000000000000000000" as const;
export const NONE_OUTCOME_ONCHAIN_ID = "0x000000000000000000000001" as const;

export const MARKET_KINDS = [
  "moneyline",      // H2H
  "total",          // тоталы
  "spread",         // форы
  "yes-no",         // да/нет
  "exact-number",   // ровно X
  "range-bucket",   // диапазоны: 0, 1–2, 3+
] as const;

export const WHITELISTED_SPORTS = [
	"basketball",
	"soccer",
	"cricket",
	"tennis",
	"baseball",
	"football",
	"esports",
	// "mma",
	// "motorsports"
] as const;

// sports that have players instead of teams in the events
export const SPORTS_WITHOUT_TEAMS: readonly (typeof WHITELISTED_SPORTS[number])[] = [
	"tennis",
] as const;

// Minimum time (ms) between placing a bet and the event start time
export const MIN_BET_LEAD_TIME_MS: Readonly<Record<typeof WHITELISTED_SPORTS[number], number>> = {
	basketball: 30 * 60000, // 30 minutes
	soccer: 15 * 60000, // 30 minutes
	cricket: 45 * 60000, // 15 minutes
	tennis: 15 * 60000, // 15 minutes
	baseball: 15 * 60000, // 15 minutes
	football: 30 * 60000, // 30 minutes
	esports: 15 * 60000,
};

export const PLAYER_REVALIDATE_INTERVAL_MS = 14_400_000 as const; // 4 hours
export const EVENT_DELAY_COUNT_AS_MAJOR_MS = 14_400_000 as const; // 4 hours
export const EVENT_BACKWARD_RESCHEDULE_COUNT_AS_MAJOR_MS = 3_600_000 as const; // 1 hour

export const SPORT_MAX_GAME_DURATION_MS_BY_KEY: Readonly<Record<typeof WHITELISTED_SPORTS[number], number>> = {
	basketball: 180 * 60000,
	soccer: 150 * 60000,
	// Use Test cricket upper bound to avoid false-positive stale detection.
	cricket: 27_000 * 60000,
	tennis: 700 * 60000,
	// Extra innings can extend well past regulation.
	baseball: 360 * 60000,
	football: 240 * 60000,
	esports: 360 * 60000,
} as const;

export const PRIZEPICKS_DNG_BOOKMAKER_KEY = "prizepicks_demons_and_goblins_" as const;
export const PRIZEPICKS_BOOKMAKER_KEY = "prizepicks" as const;

export const WHITELISTED_BOOKMAKERS = [ PRIZEPICKS_BOOKMAKER_KEY, "caesars", "betr", PRIZEPICKS_DNG_BOOKMAKER_KEY ] as const;

export const WINNING_OUTCOME_ID_MAGIC_ABSENT = "magic-id--absent" as const;
export const WINNING_OUTCOME_ID_MAGIC_EXACT_HIT = "magic-id--exact-hit" as const;
export const WINNING_OUTCOME_ID_MAGIC_EVENT_CANCELLED = "magic-id--event-cancelled" as const;
export const WINNING_OUTCOME_ID_MAGIC_NONE = "magic-id--none" as const;
export const WINNING_OUTCOME_ID_MAGIC_MAJOR_RESCHEDULE = "magic-id--major-reschedule" as const;

export const OFFCHAIN_FANTASY_LEAGUE_INITIAL_PARTICIPANT_BALANCE_AMOUNT = 1000 as const;
export const BET_CANCELLATION_RETURN_PERCENTAGE = 80 as const;

export const FTP_STREAK_MILESTONES = [
	{ day: 3, points: 10 },
	{ day: 7, points: 25 },
	{ day: 14, points: 50 },
	{ day: 21, points: 100 },
] as const;

export type FtpStreakMilestoneDay = (typeof FTP_STREAK_MILESTONES)[number]["day"];

export const FTP_STREAK_MILESTONE_DAYS = FTP_STREAK_MILESTONES.map((milestone) => milestone.day) as FtpStreakMilestoneDay[];
